export default {
  errors: {
    invalid: {
      header: "We weren't able to verify your information",
      body: 'Please double check your information and try again.',
    },
    cantReachCarrier: {
      header: "We weren't able to verify your information",
      body: 'You can try again or present your card at the clinic.',
    },
    insuranceNotActive: {
      header: 'This insurance card is no longer active',
      body: 'You can try again or present your card at the clinic.',
    },
    flags: {
      header: `This clinic doesn't accept {{insurance_type}}`,
      body: 'You can continue and use another form of insurance at the clinic.',
    },
    coverageError: {
      title: "We weren't able to verify your information",
      description: 'You can try again or present your card at the clinic.',
    },
  },
  helpfulHint:
    "We couldn't quite read everything on your card. Please enter your information below and bring your card with you to the visit just in case.",
  helpfulHintTitle: "We couldn't quite read everything on your card.",
  helpfulHintBody:
    'Please enter your information below and bring your card with you to the visit just in case.',
  mobileAddInsuranceController: {
    scanningYourInsurance: 'Scanning your insurance',
    addPhotosOfYourInsuranceCard: 'Add photos of your insurance card',
    willSendInsuranceToClinic: "We'll send your insurance to the clinic to verify",
    completeYourInsuranceDetails: 'Complete your insurance details',
    scanningAndSavingPhotos: 'Scanning and saving photos...',
    insuranceCardPhotosSaved: 'Insurance card photos saved',
    addingInsuranceToYourAccount: 'Adding insurance to your account...',
    sendingYourInsuranceToTheClinic: 'Sending your insurance to the clinic...',
  },
  mobileAddInsurance: {
    placeOnFlatSurface: 'Place card on a flat, well lit surface without glare, and tap below.',
    frontOfCard: 'Front of card',
    backOfCard: 'Back of card',
    flipCardOverAnd: 'Flip card over and tap button below to capture the back of card.',
    takingTooLong: 'Taking too long? Enter manually',
  },
  insuranceCard: {
    takeAPhoto: 'Take a photo',
  },
  insuranceFileUpload: {
    addFrontOfCard: 'Add front of card',
    addBackOfCard: 'Add back of card',
    haveCardPhotoFront: 'Have a photo of the front of your card?',
    uploadImage: 'Upload Image',
  },
  addInsurance: {
    capitalize: 'Add insurance',
    capitalCase: 'Add Insurance',
  },
  saveInsurance: 'Save insurance',
  updateInsurance: 'Update insurance',
  insuranceForm: {
    cardholderDetails: 'Cardholder details:',
    cardholderDetailsShort: 'Cardholder details',
    insuranceCarrier: 'Insurance Carrier',
    insuranceType: 'Insurance Type',
    memberId: 'Member ID',
    firstName: 'First Name',
    lastName: 'Last Name',
    yourName: 'Your name',
    skipAddingInsurance: 'Skip adding insurance',
    skipUploadingPhotos: 'Skip uploading photos',
    imNotUsingInsurance: "I'm not using insurance",
  },
  insuranceTypes: {
    other: 'Other',
    dontKnow: "Don't Know",
  },
};
